//
// DataDefinitionController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModelController";
import "./DataItemInfo";

var DataDefinitionController = createModule("BIRD::DataDefinitionController", ["BIRD::BIRDModelController"], EventDispatcher, [
    {
        METADATA_CHANGED: 50007,
    },
    ,
    ,
    ,
    {
        getDataItemInfo: [1,1],
        getDataItemInfos: [[1],[1]],
    },
    ,
    ,
]);
export default DataDefinitionController;
